import type { ICatalog, ILocalizedText } from '@platform/core/types';
import type { IOrderedSummary } from './IOrderedSummary';

/**
 * Підпис активної пігулки верхнього меню на сторінці дочірньої таблиці (прототип v4: дочірні модулі — окремі модулі простору, тож пігулка
 * називає таблицю: «Закони · Поправки», «Аналіз · Причини (fishbone)»): тип запису маршруту, якщо він не головний і є модулем простору
 * (`order` каталогу простору — позиція в w.modules); інакше null — пігулка називає модуль. Чиста функція.
 */
export function chipTable(catalog: ICatalog | undefined, moduleKey: string | undefined, rtKey: string | undefined,
  label: (text: ILocalizedText | null | undefined) => string): string | null {
  if (!moduleKey || !rtKey) return null;
  const rt = catalog?.modules.find((m) => m.key === moduleKey)?.recordTypes.find((r) => r.key === rtKey);
  return rt && !rt.main && typeof (rt as IOrderedSummary).order === 'number' ? label(rt.name) || null : null;
}
